var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.lgSpecificFields, function(item) {
      return _c("div", { key: item.seq, staticClass: "form-row div-valign" }, [
        item.dataType == "string"
          ? _c("div", { staticClass: "form-group col-md-12" }, [
              _c("label", [_vm._v(_vm._s(item.label))]),
              item.required == "Y"
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData[item.fieldName],
                    expression: "formData[item.fieldName]"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: item.required === "Y" },
                    expression: "{ required: item.required === 'Y' }"
                  }
                ],
                ref: item.fieldName,
                refInFor: true,
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has(item.fieldName)
                },
                attrs: {
                  name: item.fieldName,
                  "data-vv-as": item.fieldName,
                  disabled: _vm.isDisabled(item.fieldName),
                  maxlength: item.maxLength,
                  type: "text"
                },
                domProps: { value: _vm.formData[item.fieldName] },
                on: {
                  blur: function($event) {
                    return _vm.gethospitalName(item.fieldName)
                  },
                  keypress: function($event) {
                    return _vm.isNumber($event, item.fieldName, item.dataType)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, item.fieldName, $event.target.value)
                  }
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has(item.fieldName),
                      expression: "errors.has(item.fieldName)"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(item.label))]
              )
            ])
          : _vm._e(),
        item.dataType == "date"
          ? _c(
              "div",
              { staticClass: "form-group col-md-6" },
              [
                _c("label", [_vm._v(_vm._s(item.label))]),
                item.required == "Y"
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                item.fieldName.length < 17
                  ? _c("span", { staticClass: "text-white" }, [
                      _vm._v("         ")
                    ])
                  : _vm._e(),
                _c("date-picker", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: item.required === "Y" },
                      expression: "{ required: item.required === 'Y' }"
                    }
                  ],
                  ref: item.fieldName,
                  refInFor: true,
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has(item.fieldName)
                  },
                  attrs: {
                    name: item.fieldName,
                    "data-vv-as": item.fieldName,
                    format: "DD/MM/YYYY",
                    disabled: _vm.isDisabled(item.fieldName),
                    lang: "th",
                    placeholder: ""
                  },
                  model: {
                    value: _vm.formData[item.fieldName],
                    callback: function($$v) {
                      _vm.$set(_vm.formData, item.fieldName, $$v)
                    },
                    expression: "formData[item.fieldName]"
                  }
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has(item.fieldName),
                        expression: "errors.has(item.fieldName)"
                      }
                    ],
                    staticClass: "help is-danger"
                  },
                  [_vm._v("กรุณากรอก " + _vm._s(item.label))]
                )
              ],
              1
            )
          : _vm._e(),
        item.dataType == "number"
          ? _c(
              "div",
              { staticClass: "form-group col-md-12" },
              [
                _c("label", [_vm._v(_vm._s(item.label))]),
                item.required == "Y"
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _c("vue-numeric", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: item.required === "Y",
                        min_value: 0.01,
                        max_value:
                          item.fieldName == "percentage"
                            ? 100.0
                            : 9999999999999999999999.99
                      },
                      expression:
                        "{\n          required: item.required === 'Y',\n          min_value: 0.01,\n          max_value:\n            item.fieldName == 'percentage'\n              ? 100.0\n              : 9999999999999999999999.99,\n        }"
                    }
                  ],
                  ref: item.fieldName,
                  refInFor: true,
                  staticClass: "form-control",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has(item.fieldName)
                  },
                  attrs: {
                    separator: ",",
                    name: item.fieldName,
                    precision: 2,
                    disabled: _vm.isDisabled(item.fieldName),
                    maxlength: item.maxLength
                  },
                  on: {
                    keypress: function($event) {
                      return _vm.isNumber($event, item.fieldName, item.dataType)
                    },
                    blur: function($event) {
                      return _vm.validPercent()
                    }
                  },
                  model: {
                    value: _vm.formData[item.fieldName],
                    callback: function($$v) {
                      _vm.$set(_vm.formData, item.fieldName, $$v)
                    },
                    expression: "formData[item.fieldName]"
                  }
                }),
                item.fieldName == "percentage"
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has(item.fieldName),
                            expression: "errors.has(item.fieldName)"
                          }
                        ],
                        staticClass: "help is-danger"
                      },
                      [_vm._v("กรุณากรอก " + _vm._s(item.label))]
                    )
                  : _vm._e(),
                item.fieldName != "percentage"
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has(item.fieldName),
                            expression: "errors.has(item.fieldName)"
                          }
                        ],
                        staticClass: "help is-danger"
                      },
                      [_vm._v(_vm._s(item.label) + " ต้องมีค่ามากกว่า 0")]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        item.dataType == "option"
          ? _c("div", { staticClass: "form-group col-md-12" }, [
              _c("label", [_vm._v(_vm._s(item.label))]),
              item.required == "Y"
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData[item.fieldName],
                      expression: "formData[item.fieldName]"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: item.required === "Y" },
                      expression: "{ required: item.required === 'Y' }"
                    }
                  ],
                  ref: item.fieldName,
                  refInFor: true,
                  staticClass: "form-control",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has(item.fieldName)
                  },
                  attrs: {
                    name: item.fieldName,
                    disabled: _vm.isDisabled(item.fieldName)
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          item.fieldName,
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function($event) {
                        return _vm.onChangeContractType($event)
                      }
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("กรุณาเลือก")
                  ]),
                  _vm._l(_vm.contractTypeList, function(option) {
                    return _c(
                      "option",
                      {
                        key: option.contractTypeId,
                        domProps: { value: option.contractTypeId }
                      },
                      [_vm._v(_vm._s(option.contractTypeDesc))]
                    )
                  })
                ],
                2
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has(item.fieldName),
                      expression: "errors.has(item.fieldName)"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(item.label))]
              )
            ])
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }